import { createSlice } from "@reduxjs/toolkit";
import uuid from "react-uuid";


    const setErrors=(state,{payload})=>{
    state.errors=payload;
    }

   
const initialState={
       errors:''
    }
    
 
const schedulerSlice=createSlice({
    name:'scheduler',
    initialState,
    reducers:{
        setErrors,
    }
})


    export const {
     setErrors:setErrorsR,
     }=schedulerSlice.actions

     export default schedulerSlice.reducer